import React from 'react'

import { Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { PayrollBundleA3innuvaButtonDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import integrationCodes from 'modules/marketplace/lib/integrationCodes'
import SyncModal from 'modules/payroll_integrations_a3innuva/components/SyncModal'

const A3innuvaSyncDataButton = () => {
  const { company } = useCurrentSession()
  const [exportModalOpen, setSyncModalOpen] = React.useState<boolean>(false)

  const onCloseSyncs = () => {
    setSyncModalOpen(false)
  }

  const { data } = useQuery(PayrollBundleA3innuvaButtonDocument, {
    variables: {
      companyId: company.id,
      datoIds: [integrationCodes.a3nom, integrationCodes.a3innuva],
    },
  })

  const integrationsData = data?.marketplace?.integrationsConnection?.nodes || []
  const companyInstallationsData = data?.marketplace?.companyInstallationsConnection?.nodes || []

  interface Integration {
    id: string
    integrationId: string
    formData?: string | null
  }
  interface Integrations {
    [key: string]: Integration
  }

  const installedIntegrations = integrationsData.reduce((acc: Integrations, current) => {
    const integration = companyInstallationsData.find((i) => i.integrationId === current.id)
    if (!integration) return acc

    acc[current.name.toLocaleLowerCase()] = integration
    return acc
  }, {})

  const handleSyncButton = () => {
    setSyncModalOpen(true)
    track(trackingEvents.payroll.userClicksSyncData, {
      company_id: company.id,
    })
  }
  const [openTooltip, toggleTooltip] = useToggle(false)
  const tooltip_visible = !installedIntegrations.hasOwnProperty('a3nom')

  return (
    <>
      {installedIntegrations.hasOwnProperty('a3innuva nómina') && (
        <Tooltip.Dialog
          attachment="bottom center"
          open={openTooltip && tooltip_visible}
          toggle={toggleTooltip}
          label={i18n.t('payroll_bundle.a3innuva_sync.tooltip')}
        >
          <Button
            type="secondary"
            onClick={handleSyncButton}
            iconName="link"
            disabled={!installedIntegrations.hasOwnProperty('a3nom')}
          >
            {i18n.t('payroll_bundle.a3innuva_sync.title')}
          </Button>
        </Tooltip.Dialog>
      )}
      {exportModalOpen && <SyncModal selectedCompany={company.id} onClose={onCloseSyncs} />}
    </>
  )
}

export default A3innuvaSyncDataButton
